<template>
  <v-text-field
    ref="text"
    :value="value"
    @input="update"
    :label="name"
    :error-messages="errorMessages"
  />
</template>

<script>

export default {
  name: 'TextMetadata',
  props: {
    name: {
      type: String,
      mandatory: true,
    },
    value: {
    },
    mandatory: {
      type: Boolean,
      mandatory: true,
    },
  },
  components: {
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    errorMessages() {
      if (!this.mandatory) {
        return null;
      }

      return !this.value ? 'Pflichfeld' : null;
    }
  },
  methods: {
    update(newValue) {
      this.$emit('input', newValue);
    },
  },
  data() {
    return {
    };
  },
};
</script>
